import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import ModalButton from '../../../atomic/Buttons/ModalButton';
import StatusModal from '../../Modals/StatusModal';
import Icon from '@material-ui/core/Icon';

const ModalButtonStyled = styled(ModalButton)`
	display: flex;
	flex-direction: column;
	justify-content: center;
  ${props => {
    if (props.alert) {
        return css`
        color: #d8000c;
        background-color: #ffbaba;
        `
    } else {
        return css`
        color: white;
        background-color: #2bd855;
        `
    }
  }}
`

const Alert = styled(Icon)`
	// font-size: 36px;
	margin-right: 4px;
	color: white;
`

const StatusButton = ({
  validText,
  invalidText,
  value,
  header,
  subheader,
  ...other
}) => {
  value.checkValidity(other);
  const status = value.primaryStatus;

  return (status === 'Valid') ? (
  <ModalButtonStyled variant="contained" modalComponent={(<StatusModal value={value} header={header} subheader={subheader} />)} {...other}>
    <Alert>check_circle</Alert>
    {validText}
  </ModalButtonStyled>
  ) : (
  <ModalButtonStyled variant="contained" alert={true} modalComponent={(<StatusModal value={value} header={header} subheader={subheader} />)} {...other}>
    <Alert>error</Alert>
    {invalidText}
  </ModalButtonStyled>
  )
}

StatusButton.propTypes = {
  value: PropTypes.object,
  validText: PropTypes.string,
  invalidText: PropTypes.string,
  header: PropTypes.string,
  subheader: PropTypes.string,
};

StatusButton.defaultProps = {
  validText: 'DONE',
  invalidText: 'MISSING'
};

export default StatusButton;
